import { CREATE_LSP, DELETE_LSP, GET_LSP, GET_LSP_BY_ID, UPDATE_LSP } from "@/api/lsp/lsp";

const state = {
  lsps: [],
  lsp: {},
  totalItems: 0,
  totalPages: 0,
  currentPage: 1,
  limit: 10,
  loading: false
};

const mutations = {
  setLsps: (state, payload) => {
    state.lsps = payload.data || [];
    state.totalItems = payload.totalItems || 0;
    state.totalPages = payload.totalPages || 0;
    state.currentPage = payload.page || 1;
    state.limit = payload.limit || 10;
  },
  setLsp: (state, payload) => {
    state.lsp = payload;
  },
  setLoading: (state, loading) => {
    state.loading = loading;
  }
};

const actions = {
  // Get all LSP
  getLsps: async ({ commit }, args) => {
    const params = args;
    commit('setLoading', true);

    try {
      const resp = await GET_LSP(params);
      if (resp.data.httpCode === 200) {
        commit("setLsps", resp.data.data);
        return resp.data.data;
      }
    } catch (err) {
      const resp = err.response;
      if (resp && resp.data && resp.data.httpCode === 404) {
        commit("setLsps", { data: [], totalItems: 0 });
      }
      throw err;
    } finally {
      commit('setLoading', false);
    }
  },

  getLspById: async ({ commit }, id) => {
    commit('setLoading', true);

    try {
      const resp = await GET_LSP_BY_ID(id);
      if (resp.data.httpCode === 200) {
        commit("setLsp", resp.data.data);
        return resp.data;
      }
    } catch (err) {
      throw err;
    } finally {
      commit('setLoading', false);
    }
  },

  createLsp: async ({ commit }, data) => {
    commit('setLoading', true);

    try {
      const resp = await CREATE_LSP(data);
      return resp.data;
    } catch (err) {
      throw err;
    } finally {
      commit('setLoading', false);
    }
  },

  updateLsp: async ({ commit }, { id, data }) => {
    commit('setLoading', true);

    try {
      const resp = await UPDATE_LSP(id, data);
      return resp.data;
    } catch (err) {
      throw err;
    } finally {
      commit('setLoading', false);
    }
  },

  deleteLsp: async ({ commit }, id) => {
    commit('setLoading', true);

    try {
      const resp = await DELETE_LSP(id);
      return resp.data;
    } catch (err) {
      throw err;
    } finally {
      commit('setLoading', false);
    }
  }
};

const getters = {
  getLsps: () => state.lsps,
  getLsp: () => state.lsp,
  getTotalItems: () => state.totalItems,
  getTotalPages: () => state.totalPages,
  getCurrentPage: () => state.currentPage,
  getLimit: () => state.limit,
  getLoading: () => state.loading
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};